import { createFileRoute } from '@tanstack/react-router'
import { DELIVERY_STATUSES, WebhookDeliveriesPage, type DeliveryStatus } from '../../../../components/webhooks/WebhookDeliveriesPage'

export const Route = createFileRoute('/$org/settings/webhooks/$subscriptionUid')({
    validateSearch: (search: Record<string, unknown>): { status?: DeliveryStatus } => ({
        status: DELIVERY_STATUSES.includes(search.status as DeliveryStatus) ? (search.status as DeliveryStatus) : undefined,
    }),
    component: WebhookDeliveriesPage,
})
